module.exports = __webpack_public_path__ + "img/unauthorized.7a07fb68.png";